webpackJsonp([213720915766396],{

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectCard = __webpack_require__(64);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ProjectCards = function ProjectCards(props) {
	  return _react2.default.createElement(
	    'div',
	    props,
	    _react2.default.createElement(
	      'div',
	      { className: 'grid grid--gutters' },
	      props.children
	    )
	  );
	};
	
	exports.default = function (props) {
	  var projects = props.projects,
	      className = props.className,
	      rest = _objectWithoutProperties(props, ['projects', 'className']);
	
	  var classes = 'projects-grid grid-wrap';
	
	  if (className !== undefined) {
	    classes = classes + ' ' + className;
	  }
	
	  return _react2.default.createElement(
	    ProjectCards,
	    _extends({ className: classes }, rest),
	    projects.map(function (_ref, i) {
	      var node = _ref.node;
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: 'grid-cell u-full u-md-1of2 u-lg-1of2' },
	        _react2.default.createElement(_ProjectCard2.default, { slug: node.fields.slug,
	          title: node.frontmatter.title,
	          client: node.frontmatter.client,
	          thumbnail: node.frontmatter.thumbnail })
	      );
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Container = __webpack_require__(23);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Header = __webpack_require__(63);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Heading = __webpack_require__(18);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _ProjectCards = __webpack_require__(48);
	
	var _ProjectCards2 = _interopRequireDefault(_ProjectCards);
	
	var _Button = __webpack_require__(47);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var meta = data.site.siteMetadata;
	  var projects = data.projects.edges;
	  var archive = data.archive.edges;
	
	  var pageTitle = "Projects";
	  var siteTitle = pageTitle + ' \u2014 ' + meta.title;
	
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { title: pageTitle },
	      _react2.default.createElement('meta', { property: 'og:title', content: siteTitle })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'header-wrap' },
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: '2', className: 'grid-wrap' },
	        pageTitle
	      )
	    ),
	    _react2.default.createElement(_ProjectCards2.default, { projects: projects }),
	    _react2.default.createElement(
	      _Header2.default,
	      { className: 'grid-wrap' },
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: '3' },
	        'Archived Projects'
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { type: 'link', to: '/projects/archive/', className: 'button--outline button--sm u-sm-full' },
	        'View Archived'
	      )
	    ),
	    _react2.default.createElement(_ProjectCards2.default, { projects: archive })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-40da6f589034cf7a18f6.js